import React from 'react';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';

interface SpaBadgeProps {
  pillar?: 'critical_minerals' | 'industrialization' | 'infrastructure' | 'governance';
  className?: string;
  size?: 'sm' | 'md';
}

const pillarColors = {
  critical_minerals: 'bg-spa-minerals/10 text-spa-minerals border-spa-minerals/30',
  industrialization: 'bg-spa-industrialization/10 text-spa-industrialization border-spa-industrialization/30',
  infrastructure: 'bg-spa-infrastructure/10 text-spa-infrastructure border-spa-infrastructure/30',
  governance: 'bg-spa-governance/10 text-spa-governance border-spa-governance/30',
};

export const SpaBadge = React.forwardRef<HTMLSpanElement, SpaBadgeProps>(({ pillar, className, size = 'md' }, ref) => {
  const { t } = useTranslation();

  if (pillar) {
    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center gap-1 rounded-full border font-medium',
          size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs',
          pillarColors[pillar],
          className
        )}
      >
        <Shield className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
        {t(`spaPillars.${pillar}`)}
      </span>
    );
  }

  return (
    <span
      ref={ref}
      className={cn(
        'spa-badge inline-flex items-center gap-1',
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs',
        className
      )}
    >
      <Shield className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
      SPA
    </span>
  );
});

SpaBadge.displayName = 'SpaBadge';